module.exports = __webpack_public_path__ + "static/img/newanli-01.7dbde538.jpg";